import FullscreenIcon from '@mui/icons-material/Fullscreen';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { useCallback } from 'react';
import ChartHeader from '../../../charts/ChartHeader';
import { RanchAreaEnum } from '../../ranchesSlice';
import { RanchWidgetAction } from './types';

type RanchWidgetHeaderProps = {
  type: RanchAreaEnum; // TODO: Rename this type to something widget specific and drop the "enum" from the name
  onHeaderAction: (actionId: RanchWidgetAction) => void;
};

export const RanchWidgetHeader = ({
  type,
  onHeaderAction,
}: RanchWidgetHeaderProps) => {
  const theme = useTheme();

  const handleAction = useCallback(
    (actionId: RanchWidgetAction) => {
      onHeaderAction(actionId);
    },
    [onHeaderAction]
  );

  return (
    <motion.div
      layout
      style={{
        width: '100%',
        height: '3.5rem',
        borderTopLeftRadius: theme.borderRadius.primary,
        borderTopRightRadius: theme.borderRadius.primary,
        padding: '0.25rem',
        backgroundColor: theme.colors.darkTheme.grey.medium,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <motion.div
        layout
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {type === RanchAreaEnum.chartArea && <ChartHeader />}
      </motion.div>
      <motion.div
        layout
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <IconButton
          aria-label='FullScreen Toggle'
          size='small'
          onClick={() => handleAction('DISPLAY_DIALOG')}
        >
          <FullscreenIcon sx={{ color: theme.colors.common.white }} />
        </IconButton>
      </motion.div>
    </motion.div>
  );
};
